// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"3fb3407c","716":"3fb3407c"}[chunkId] + ".chunk.css";
};